import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import FindYourWay from "@/pages/FindYourWay";
import PathwayPage from "@/pages/PathwayPage";
import JourneyRoute from "@/pages/JourneyRoute";
import DirectionHub from "@/pages/DirectionHub";
import UnderstandingHub from "@/pages/UnderstandingHub";
import ArticlePage from "@/pages/ArticlePage";
import ToolPage from "@/pages/ToolPage";
import SupportHub from "@/pages/SupportHub";
import Directory from "@/pages/Directory";
import About from "@/pages/About";
import Organisations from "@/pages/Organisations";
import Contact from "@/pages/Contact";
import UrgentHelp from "@/pages/UrgentHelp";
import InfoPage from "@/pages/InfoPage";
import Brand from "@/pages/Brand";
import { NotFoundBlock } from "@/components/site/Loading";
import { AuthProvider, RequireStaff } from "@/admin/AuthContext";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminOverview from "@/admin/AdminOverview";
import AdminArticles from "@/admin/AdminArticles";
import ArticleEditor from "@/admin/ArticleEditor";
import AdminCategories from "@/admin/AdminCategories";
import AdminDirectory from "@/admin/AdminDirectory";
import AdminHomepage from "@/admin/AdminHomepage";
import AdminEnquiries from "@/admin/AdminEnquiries";
import AdminAudit from "@/admin/AdminAudit";
import AdminUsers from "@/admin/AdminUsers";
import AdminFeedback from "@/admin/AdminFeedback";
import AdminReviews from "@/admin/AdminReviews";

const AdminOnly = ({ children }) => <RequireStaff adminOnly>{children}</RequireStaff>;

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/find-your-way" element={<FindYourWay />} />
          <Route path="/find-your-way/:slug" element={<JourneyRoute />} />
          <Route path="/find-your-way/:slug/guide" element={<PathwayPage />} />
          <Route path="/direction" element={<DirectionHub />} />
          <Route path="/direction/:slug" element={<ArticlePage hub="direction" />} />
          <Route path="/understanding" element={<UnderstandingHub />} />
          <Route path="/understanding/:slug" element={<ArticlePage hub="understanding" />} />
          <Route path="/resources/:slug" element={<ToolPage />} />
          <Route path="/support" element={<SupportHub />} />
          <Route path="/directory" element={<Directory />} />
          <Route path="/about" element={<About />} />
          <Route path="/for-organisations" element={<Organisations />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/urgent-help" element={<UrgentHelp />} />
          <Route path="/privacy" element={<InfoPage page="privacy" />} />
          <Route path="/terms" element={<InfoPage page="terms" />} />
          <Route path="/safeguarding" element={<InfoPage page="safeguarding" />} />
          <Route path="/accessibility" element={<InfoPage page="accessibility" />} />
          <Route path="/brand" element={<Brand />} />
          <Route path="*" element={<NotFoundBlock />} />
        </Route>
        <Route path="/admin/*" element={
          <AuthProvider>
            <Routes>
              <Route path="login" element={<AdminLogin />} />
              <Route element={<RequireStaff><AdminLayout /></RequireStaff>}>
                <Route index element={<AdminOverview />} />
                <Route path="articles" element={<AdminArticles />} />
                <Route path="articles/:id" element={<ArticleEditor />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="directory" element={<AdminDirectory />} />
                <Route path="homepage" element={<AdminHomepage />} />
                <Route path="reviews" element={<AdminReviews />} />
                <Route path="feedback" element={<AdminOnly><AdminFeedback /></AdminOnly>} />
                <Route path="enquiries" element={<AdminOnly><AdminEnquiries /></AdminOnly>} />
                <Route path="audit" element={<AdminOnly><AdminAudit /></AdminOnly>} />
                <Route path="users" element={<AdminOnly><AdminUsers /></AdminOnly>} />
              </Route>
            </Routes>
          </AuthProvider>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
